import { FC } from 'react';

import {
  Heading,
  Icon,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@chakra-ui/react';

import { Card } from '../card';
import { Individual, PeopleGroup } from '../../assets';
import { Leader } from '../../types';
import { LeaderboardPanel } from './leaderboardPanel';

export interface LeaderboardProps {
  teamsAllowed: boolean;
  individualLeaders: Leader[];
  teamLeaders?: Leader[];
}

export const Leaderboards: FC<LeaderboardProps> = ({
  teamsAllowed,
  individualLeaders,
  teamLeaders,
}) => (
  <Card mb={6}>
    <Stack spacing={4}>
      <Heading size="md" color="brand.primary.swatch1">
        Fundraising Leaderboard
      </Heading>
      <Tabs isFitted>
        <TabList>
          <Tab>
            <Icon
              as={Individual}
              boxSize="24px"
              color="brand.additional.link"
            />
            <Text marginInlineStart={2}>Individuals</Text>
          </Tab>
          {teamsAllowed && (
            <Tab>
              <Icon
                as={PeopleGroup}
                boxSize="24px"
                color="brand.additional.link"
              />
              <Text marginInlineStart={2}>Teams</Text>
            </Tab>
          )}
        </TabList>

        <TabPanels ml="-20px">
          <TabPanel>
            <LeaderboardPanel leaders={individualLeaders} isTeamTab={false} />
          </TabPanel>
          {teamsAllowed && (
            <TabPanel>
              <LeaderboardPanel leaders={teamLeaders || []} isTeamTab />
            </TabPanel>
          )}
        </TabPanels>
      </Tabs>
    </Stack>
  </Card>
);
